(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    

  const handleIntersection = (entries, observer) => {

    if ( !entries[0].isIntersecting ) return;

    observer.unobserve( complementary );

    const url = complementary.dataset.url;

    fetch( url )

      .then( response => response.text() )

      .then( text => {

        const html = document.createElement('div');

        html.innerHTML = text;

        const recommendations = html.querySelector( '.complementary' );

        if ( recommendations && recommendations.innerHTML.trim().length ) {

          complementary.innerHTML = recommendations.innerHTML;

        }

      })

      .catch(e => {

        console.error(e);

      });

  };

  const complementary = document.querySelector( '.complementary' );

  if ( complementary ) {

    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe( complementary );

  }

  const pdpMainAtc = document.getElementById( 'pdp-main-atc' );

  const pdpStickyBar = document.getElementById( 'pdp-sticky-bar' );

  if ( pdpMainAtc && pdpStickyBar ) {

    const pdpIo = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        pdpStickyBar.classList.toggle( 'is-visible', !entry.isIntersecting );

      });

    }, { rootMargin : '0px 0px -80px 0px' });

    pdpIo.observe( pdpMainAtc );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products"]) return;
  try {
    

  const handleIntersection = (entries, observer) => {

    if (!entries[0].isIntersecting) return;

    observer.unobserve( related );

    const url = related.dataset.url;

    fetch( url )

      .then( response => response.text() )

      .then( text => {

        const html = document.createElement('div');

        html.innerHTML = text;

        const recommendations = html.querySelector( '.related' );

        if ( recommendations && recommendations.innerHTML.trim().length ) {

          related.innerHTML = recommendations.innerHTML;

        }

      })

      .catch(e => {

        console.error(e);

      });

  };

  const related = document.querySelector( '.related' );

  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe( related );


  } catch(e) { console.error(e); }
})();
})();
